import * as React from 'react';
import type { About } from '@chess/platform-web';

// The settings section "About", drawn from props only: the app's summary and
// the projects it is built on, each with what it does here and its licence.

export interface AboutSectionProps {
  name: string;
  about: About;
}

export const AboutSection: React.FC<AboutSectionProps> = ({ name, about }) => (
  <section className="panel settings-about" aria-labelledby="settings-about-title">
    <h2 id="settings-about-title">About {name}</h2>
    <p className="settings-about-summary">{about.summary}</p>
    <h3 className="settings-about-h3">Built with</h3>
    <ul className="settings-about-credits">
      {about.credits.map((c) => (
        <li key={c.name}>
          <a href={c.url} target="_blank" rel="noreferrer" data-track="settings.about.credit">
            {c.name}
          </a>
          <span className="settings-about-role">{c.role}</span>
          <span className="settings-about-licence">{c.licence}</span>
        </li>
      ))}
    </ul>
  </section>
);
